<template>
	<footer class="footer">
		<div v-if="footer && footerLinks" class="container">
			<span class="footer-copyright">
				&copy;{{ new Date().getFullYear() }} - {{ footer.text }}
			</span>
			<ul>
				<li
					v-for="(link, index) in footerLinks"
					:key="index"
				>
					<NuxtLink
						:key="link.sys.id"
						:to="localePath(`/${link.fields.slug.replace('/', '')}`)"
					>
						{{ link.fields.pageName }}
					</NuxtLink>
				</li>
				<li class="language-switcher">
					<LangSwitcher />
				</li>
			</ul>
		</div>
		<div class="footer-consent-links">
			<div class="container">
				<ul>
					<li>
						<a href="#" @click="showCookiePreference">{{ $t('cookies.buttonShowCookiePreferences') }}</a>
					</li>
					<li>
						<a :href="$t('pages.privacy-policy.url')">{{ $t('pages.privacy-policy.title') }}</a>
					</li>
					<li>
						<a :href="$t('pages.terms-and-conditions.url')">{{ $t('pages.terms-and-conditions.title') }}</a>
					</li>
				</ul>
			</div>
		</div>
	</footer>
<!--	<pre>{{footer}}</pre>-->
</template>
<script setup>
const localePath = useLocalePath();
const { locale } = useI18n();

const { data: footerData } = await useFetch('/api/contentful/footer', {
	query: {
		locale: `${locale.value}-CA`
	},
	key: `footer-${locale.value}-CA`
});

const footerLinks = computed(() => {
	const pages = footerData?.value?.fields?.items[0]?.fields.pages;

	if (!pages) {
		return [];
	}

	return pages
		.filter(page => page.fields?.pageName !== 'Home')
		.map(page => ({
			...page,
			fields: {
				...page.fields,
				// Use redirectTo if it exists, otherwise use slug
				slug: page.fields?.redirectTo || page.fields?.slug
			}
		}));
});

const footer = computed(() => {
	return footerData?.value?.fields;
});

const showCookiePreference = (event) => {
	if(process.client) {
		event.preventDefault();

		const cookieBannerButton = document.getElementById('silktide-cookie-icon');

		if(cookieBannerButton) {
			cookieBannerButton.click();
		}
	}
};

</script>
<style lang="scss">
@use '~/assets/scss/components/Footer.scss';
</style>